// extracted by css-extract-rspack-plugin
export default {"container":"container-B21VSi","slider":"slider-dahDLm","sliderList":"sliderList-I5o1lL","sliderCard":"sliderCard-ZLWJUP"};